import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GuardLoadingService {
  readonly loading = signal<boolean>(false);

  show(): void {
    this.loading.set(true);
  }

  hide(): void {
    this.loading.set(false);
  }
}
